import { render } from "./humVideoListKxjMode.vue?vue&type=template&id=5dd99a18&scoped=true"
import script from "./humVideoListKxjMode.vue?vue&type=script&lang=js"
export * from "./humVideoListKxjMode.vue?vue&type=script&lang=js"

import "./humVideoListKxjMode.vue?vue&type=style&index=0&id=5dd99a18&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd99a18"]])

export default __exports__